import React, { useState, useEffect } from 'react';

import { Box } from 'native-base';
import { faAward, faCartShopping, faCoins, faLink, faCakeCandles, faUserCircle, faGift, faUserPlus, faHeart } from '@fortawesome/free-solid-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

import { LinkExtension, observer, useAppSettings, useSpringBigStore } from '@springbig/shared';

import Image from '~/shared/Image';
import { SpIcon } from '~/shared/Icon';
import { Caption, H4 } from '~/shared/Typography';
import { useGeneralStyles, useMessagesStyles } from '~/shared/styles';
import { useAppNavigate } from '~/pages';
import Pressable from '~/shared/Pressable';

type ExtensionType = 'any_link' | 'digital_coupon' | 'birthday' | 'interests' | 'referral' | 'profile' | 'shop online' | 'bonus_points' | 'instant_points' | 'target_wallet';
type WalletType = 'referral' | 'interests' | 'birthday' | 'profile' | 'shop online' | 'home';

export type MessageLinkBoxProps = {
    url: string;
    type: ExtensionType;
    walletType?: WalletType;
    link?: LinkExtension;
    stashboardKey: string;
}

type ExtensionProps = {
    type: ExtensionType;
    icon: IconDefinition;
    caption: string;
    title: string;
    prefix: string;
    wallet_type?: WalletType;
}

const messageLinkValues: ExtensionProps[] = [
    {
        type: 'any_link',
        icon: faLink,
        caption: 'View more',
        prefix: '',
        title: '',
    },
    {
        type: 'digital_coupon',
        icon: faGift,
        caption: 'View offers',
        prefix: 'offers',
        title: 'Click here to see your new offer available',
    },
    {
        type: 'bonus_points',
        icon: faCoins,
        caption: 'View offers',
        prefix: 'offers',
        title: 'Click here to see your new bonus points offer available',
    },
    {
        type: 'instant_points',
        icon: faAward,
        caption: 'View rewards',
        prefix: 'rewards',
        title: 'Points have been added to you account! Click here to view rewards',
    },
    {
        type: 'profile',
        icon: faUserCircle,
        caption: 'View profile',
        prefix: 'profile',
        title: 'Click here to make sure your account is up to date',
    },
    {
        type: 'birthday',
        icon: faCakeCandles,
        caption: 'View my information',
        prefix: 'profile',
        title: 'Click here to make sure your birthday is up to date',
    },
    {
        type: 'interests',
        icon: faHeart,
        caption: 'View interests',
        prefix: 'profile',
        title: 'Click here to tell us about you for a more personalized experience',
    },
    {
        type: 'referral',
        icon: faUserPlus,
        caption: 'View refer link',
        prefix: 'refer',
        title: 'Click here to refer a friend!',
    },
    {
        type: 'shop online',
        icon: faCartShopping,
        caption: 'Shop Online',
        prefix: 'checkout',
        title: 'Click here to view our menu'
    },
    {
        type: 'target_wallet',
        icon: faAward,
        caption: 'View rewards',
        prefix: 'rewards',
        title: 'Click here to view rewards',
    },
];

// TODO: remake this entire component from the ground up when we have some spare time, this is such a mess...

const MessageExtensionBox = ({ type, walletType, url, link, stashboardKey }: MessageLinkBoxProps) => {

    const {
        link_box_background,
        link_box_border,
        link_box_icon,
        text,
        icon,
        link_box_icon_background
    } = useMessagesStyles();
    const gStyle = useGeneralStyles();
    const { redirections } = useAppSettings();
    const { walletId } = useSpringBigStore();

    const validImage = link && link.thumbnail?.url ? `${link.thumbnail?.url}?h=50&w=100` : null;
    const { navigate, params } = useAppNavigate();
    const [extensionProps, setExtensionProps] = useState<ExtensionProps[]>();

    useEffect(() => {
        if (type === 'any_link') {
            const _extensionProps = messageLinkValues.filter(l => l.type === 'any_link');
            setExtensionProps(_extensionProps);
        }

        // 'referral' | 'interests' | 'birthday' | 'profile' | 'shop online'
        if (type !== 'any_link' && type === 'target_wallet' && url) {
            let _extensionProps = messageLinkValues.filter((el) => el.type === walletType && url.includes(el.prefix));
            console.log(_extensionProps)
            setExtensionProps(_extensionProps);
        }

        if (type !== 'any_link' && type !== 'target_wallet' && url) {
            const _extensionProps = messageLinkValues.filter((el) => el.type === type)
            setExtensionProps(_extensionProps);
        }

    }, [type, url]);



    const redirectUrl = (_url: string, prefix: string) => {

        observer.emit('any-link-clicked', {
            type: type || 'none',
            url: _url,
            _key: stashboardKey
        });

        switch (type) {
            case 'any_link':
                window.open(url, '_blank', 'noopener,noreferrer');
                break;
            case 'digital_voucher':
                navigate(`w/${params.wallet_id || walletId}${redirections[prefix] || '/offers'}`);
                break;
            case 'bonus_points':
                navigate(`w/${params.wallet_id || walletId}${redirections[prefix] || '/offers'}`);
                break;
            case 'instant_points':
                navigate(`w/${params.wallet_id || walletId}${redirections[prefix] || '/rewards'}`);
        }

        if (/.+rewards/i.test(_url)) {
            navigate(`w/${params.wallet_id || walletId}${redirections[prefix] || '/rewards'}`);
        }

        if (/.+offers/i.test(_url)) {
            navigate(`w/${params.wallet_id || walletId}${redirections[prefix] || '/offers'}`);
        }

        if (/.+profile/i.test(_url)) {
            navigate(`w/${params.wallet_id || walletId}${redirections[prefix] || '/profile'}`);
        }

        if (/.+checkout/i.test(_url)) {
            // navigate('Cart');
        }
    };

    if (extensionProps) {
        return (
            <Box
                position='relative'
                justifyContent={'center'}
                p={2}
            >
                {extensionProps.map((extension, i) => (

                    <Pressable
                        key={`${i * Math.random()}-${extension.type}`}
                        borderRightRadius={8}
                        borderLeftRadius={8}
                        px={4}
                        py={2}
                        borderWidth={1}
                        mr={3}
                        flexDirection={'row'}
                        borderColor={link_box_border}
                        bg={link_box_background}
                        w={'56'}
                        h={'20'}
                        alignItems={'center'}
                        onPress={() => redirectUrl(url, extension.prefix)}
                    >
                        <Box
                            position={'absolute'}
                            top={-8}
                            left={-8}
                            bg={link_box_icon_background}
                            p={1}
                            borderRadius={'100'}
                        >
                            <SpIcon
                                color={icon || 'white'}
                                size={12}
                                icon={extension.icon}
                            />
                        </Box>
                        <Box>
                            {
                                validImage ? <Image
                                    borderLeftRadius={8}
                                    borderRightRadius={8}
                                    w={'16'}
                                    h={'16'}
                                    uri={validImage}
                                /> : <Box>
                                    <SpIcon
                                        color={link_box_icon || 'white'}
                                        size={54}
                                        icon={extension.icon}
                                    />
                                </Box>
                            }
                        </Box>
                        <Box w={'32'} ml={2} h={'100%'} justifyContent='space-between'>
                            <H4 fontWeight={'normal'} color={gStyle.text} fontSize={10}>{link && link.title ? link.title : extension.title}</H4>
                            <Caption textAlign={'right'} color={gStyle.link} fontSize={11}>{extension.caption}</Caption>
                        </Box>
                    </Pressable>
                ))
                }
            </Box>
        );
    }

    return (
        <Box></Box>
    );

};

export default MessageExtensionBox;
